import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { get } from 'lodash';

import { iconConstants, routesConstants } from '@/constants';
import Icons from '@/icons';
import { OtpInput } from '@/component';
import { Button, Backdrop } from '@/kaya';
import { useArtistStore } from '@/store';

import styles from './OtpScreen.module.scss';

interface OtpScreenProps {
  visible: boolean;
  phoneNumber: string;
  isLoading: boolean;
  handleResend: () => void;
  setVisible: (visible: boolean) => void;
  handleVerify: (otp: string) => void;
  handleSubmit: (otp: string) => void;
}
const OtpScreen = (props: OtpScreenProps) => {
  const { artist } = useArtistStore();
  const { visible, setVisible, handleVerify, handleSubmit, handleResend, phoneNumber, isLoading } =
    props;

  const [otp, setOtp] = useState('');

  const navigate = useNavigate();

  return visible ? (
    <div
    // className={cx(styles.OtpScreenWrapper, { [styles.visible]: !visible })}
    // onClick={(e) => {
    //   setVisible(!visible);
    // }}
    >
      <Backdrop visible={visible} setVisible={setVisible} />
      <div className={styles.OtpScreen}>
        <h1 className={styles.title}>Enter OTP</h1>
        <p className={styles.title2}>We have sent a 6 digit otp on your phone number</p>
        <Button
          className={styles.input}
          suffixIcon={<Icons type={iconConstants.ICONS.EDIT} />}
          onSuffixIconClick={() => {
            setVisible(false);
            navigate(routesConstants.ROUTES.PERSONAL_INFO);
          }}
        >
          {phoneNumber}
        </Button>

        <OtpInput otp={otp} setOtp={setOtp} />
        <Button
          className={styles.submitBtn}
          type="Primary"
          onClick={() => handleSubmit(otp)}
          isLoading={isLoading}
        >
          Verify
        </Button>
        <div className={styles.resendText}>
          <p className={styles.desc}>Didn’t receive an email? </p>
          <a className={styles.resendBtn} onClick={handleResend}>
            Resend It
          </a>
        </div>
      </div>
    </div>
  ) : null;
};

export default OtpScreen;
